import { useEffect, useState } from 'react';
import { render, NODE_PARAGRAPH } from 'storyblok-rich-text-react-renderer';
import { Col, Container, Row } from 'components/atoms/Grid';
import Text from 'components/atoms/Text';
import Colors from 'components/tokens/Colors';
import styled from 'styled-components';
import Button from 'components/atoms/Button';
import { sbEditable } from '@storyblok/storyblok-editable';
import { getAssetURL } from 'helpers/getAssetURL';
import LenteNewsletterSubscribeForm from 'components/newsletter';
import placeholder from 'assets/image_placeholder.png';
import { Modal } from 'antd';

export default function NewsletterEducationCTA(props) {
    const [isVisibleModalCancel, setIsVisibleModalCancel] = useState(false);
    const educationPath = window.location.pathname.includes('educacao');

    const scrollToID = hash => {
        if (!hash) return;
        const hasHowToJoin = document.querySelector(hash);

        if (!hasHowToJoin) return;

        hasHowToJoin.scrollIntoView({
            behavior: 'smooth'
        });
    };
    const showModal = () => {
      setIsVisibleModalCancel(true);
    };
    const handleClose = () => {
      setIsVisibleModalCancel(false);
    };
    useEffect(() => {
        scrollToID(window.location.hash);
    }, []);

    if (props?.layout === 'layout_1') {
        return (
            <Container px="2.5 5" {...sbEditable(props)} id="lente">
                <ColoredRow pt="5" pb="5" alignItems="flex-end">
                    <Col px="1.5 4" size="12">
                        <Row>
                            <Col size="8 3">
                                <StyledImg
                                    src={getAssetURL(props?.logo?.filename) || placeholder}
                                    alt={props?.logo?.alt}
                                />
                            </Col>
                            <Col size="hidden 2" />
                            <Col size="11 5" pl="1 1.5">
                                {render(props?.description, {
                                    nodeResolvers: {
                                        [NODE_PARAGRAPH]: children => (
                                            <Row>
                                                <Col size="12" mt={children?.length === 3 ? '4 0' : '2'}>
                                                    <Text size="12 16" lineHeight="16 21">
                                                        {children}
                                                    </Text>
                                                </Col>
                                            </Row>
                                        )
                                    }
                                })}
                            </Col>
                        </Row>
                    </Col>
                </ColoredRow>
                <Row alignItems="stretch" mb="5 0">
                    <Col size="hidden 2">
                        <ColoredRow style={{ height: '100%' }} color={Colors.lightGrey} />
                    </Col>
                    <Col size="12 10">
                        <ColoredRow color={Colors.black} pt="3" pb="3" alignItems="center">
                            <Col size="12 4" mb="3 0" px="1.5 2">
                                <StyledText body2 color={Colors.white}>
                                    Para se inscrever, deixe seu e-mail:
                                </StyledText>
                            </Col>
                            <LenteNewsletterSubscribeForm />
                        </ColoredRow>
                    </Col>
                </Row>
            </Container>
        );
    }

    if (props?.layout === 'layout_2') {
        return (
            <StyledOverContainer px="2.5 5" {...sbEditable(props)} id="intervalo" education={educationPath}>
                <ColoredRow pt="5" pb="5" mt="5 8" alignItems="flex-end" color={Colors.black}>
                    <Col px="1.5 4" size="12">
                        <Row>
                            <Col size="8 3">
                                <StyledImg
                                    src={getAssetURL(props?.logo?.filename) || placeholder}
                                    alt={props?.logo?.alt}
                                />
                            </Col>
                            <Col size="hidden 2" />
                            <Col size="11 5" pl="1 1.5">
                                {render(props?.description, {
                                    nodeResolvers: {
                                        [NODE_PARAGRAPH]: children => (
                                            <Row>
                                                <Col size="12" mt={children?.length === 3 ? '4 0' : '2'}>
                                                    <Text color={Colors.white} size="12 16" lineHeight="16 21">
                                                        {children}
                                                    </Text>
                                                </Col>
                                            </Row>
                                        )
                                    }
                                })}
                            </Col>
                        </Row>
                    </Col>
                </ColoredRow>
                <Row alignItems="stretch" mb="5 0">
                    <Col size="hidden 2">
                        <ColoredRow style={{ height: '100%' }} color={Colors.educationGreen} />
                    </Col>
                    <Col size="12 10">
                        <ColoredRow color={Colors.white} pt="3" pb="3" alignItems="center">
                           <Col size="12 4" mb="3 0" px="1.5 2">
                              <StyledText body2 color={Colors.black}>
                                  Para se inscrever, clique no botão:
                                   <Button
                                      style={{ width: '200px', margin: '0 12px', color: 'black', backgroundColor: Colors.educationGreen }}
                                      onClick={showModal}
                                   >
                                     Inscreva-se
                                   </Button>
                              </StyledText>
                           </Col>
                           <Modal
                              open={isVisibleModalCancel}
                              onCancel={handleClose}
                              footer={null}
                              centered
                           >
                              <LenteNewsletterSubscribeForm url={"https://intervalolupa.substack.com/embed"}/>
                           </Modal>
                        </ColoredRow>
                    </Col>
                </Row>
            </StyledOverContainer>
        );
    }

    return null;
}

const StyledOverContainer = styled(Container)`
    margin-bottom: ${({ education }) => (education ? 32 : -276)}px;
    z-index: 1;
    position: relative;

    @media (min-width: 768px) {
        margin-bottom: ${({ education }) => (education ? 32 : -166)}px;
    }
`;

const ColoredRow = styled(Row)`
    background-color: ${({ color }) => color ?? Colors.primary};
    z-index: 1;
`;

const StyledImg = styled.img`
    width: 100%;
`;

const StyledText = styled(Text)`
    @media (min-width: 1160px) {
        white-space: nowrap;
    }
`;
